/**
 * CR043: READ Status Badge Component
 */

import { Badge } from "@/components/ui/badge";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { CheckCircle2, RefreshCw, AlertTriangle, XCircle, SkipForward, Clock } from "lucide-react";
import { READ_STATUS_CONFIG, type ReadStatus } from "@/lib/read-phase/types";

interface ReadStatusBadgeProps {
  status: ReadStatus;
  showTooltip?: boolean;
}

const ICONS = {
  check: CheckCircle2,
  refresh: RefreshCw,
  alert: AlertTriangle,
  x: XCircle,
  skip: SkipForward,
} as const;

export function ReadStatusBadge({ status, showTooltip = true }: ReadStatusBadgeProps) {
  const config = READ_STATUS_CONFIG[status] || READ_STATUS_CONFIG.pending;
  const Icon = ICONS[config.icon] || Clock;

  const badge = (
    <Badge className={`${config.color} text-white`}>
      <Icon className={`h-3 w-3 mr-1 ${status === 'RETRYING' ? 'animate-spin' : ''}`} />
      {config.label}
    </Badge>
  );

  if (!showTooltip) return badge;

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          {badge}
        </TooltipTrigger>
        <TooltipContent>
          <p className="max-w-xs">{config.tooltip}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
